import service from './axios';

// 获取店员列表
export const fetchClerks = (params) => {
  return service({
    method: 'get',
    url: '/manage/clerks',
    params
  });
};

// 添加店员（支持权限）
export const addClerk = (userId, permissions = []) => {
  return service({
    method: 'post',
    url: '/manage/clerks',
    data: { user_id: userId, permissions }
  });
};

// 批量添加店员
export const batchAddClerks = (userIds) => {
  return service({
    method: 'post',
    url: '/manage/clerks/batch',
    data: { user_ids: userIds }
  });
};

// 移除店员
export const removeClerk = (id) => {
  return service({
    method: 'delete',
    url: `/manage/clerks/${id}`
  });
};

// 更新店员权限
export const updateClerkPermissions = (id, permissions) => {
  return service({
    method: 'put',
    url: `/manage/clerks/${id}`,
    data: { permissions }
  });
};

// 搜索可添加为店员的用户
export const fetchAvailableUsers = (params) => {
  return service({
    method: 'get',
    url: '/manage/clerks/available',
    params
  });
};
